<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { usucon } from "../store";
    import Carreras from "../componentes/Carreras.svelte";
    import Paises from "../componentes/paises.svelte";

    const dispatch = createEventDispatcher();

    import Api from "../api";
    const api = new Api("graduado");
    const apiRol = new Api("roles");

    export let graduadoId;
    export let origen;

    let displayModal = "none";
    let displayModalProcesando = "none";
    let displayModalRespuesta = "none";
    let displayModalMensaje = "";
    let paises_display = "none";

    let gg;
    let roles = [];
    let ficha = "usuario";

    let hayError = {
        error: false,
        mensaje: "",
    };

    let campos = [
        "clave_ucc",
        "email",
        "emailalt",
        "emaillab",
        "domicilio",
        "localidad",
        "provincia",
        "pais",
        "cod_pais",
        "hijos",
        "familiaEnLaUcc",
        "telefonoFijo",
        "telefonoMovil",
        "linkedin",
        "activoLaboral",
        "profIndependiente",
        "fundador",
        "emprendedor",
        "trabajaUcc",
        "trabajaUccFabiola",
        "proveedorUcc",
        "organizacion",
        "webOrganizacion",
        "uccEventoAsistio",
        "uccEvento",
    ];

    let sexos = [
        { id: "", desc: "" },
        { id: "F", desc: "Femenino" },
        { id: "M", desc: "Masculino" },
    ];

    let trabaja = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let fundador = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let emprendedor = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let ucc = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let fabiola = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let proveedor = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let independiente = [
        { id: "X", desc: "" },
        { id: "S", desc: "SI" },
        { id: "N", desc: "NO" },
    ];

    let uccEventoAsistio = [
        { id: "X", desc: "" },
        { id: "NO", desc: "NO" }, // ERA 0
        { id: "SI", desc: "SI" }, // ERA 1
        { id: "10", desc: "10" },
        { id: "15", desc: "15" },
        { id: "25", desc: "25" },
        { id: "50", desc: "50" },
        { id: "CHARLA", desc: "CHARLA" },
        { id: "OTRO", desc: "OTRO" },
    ];

    $: {
        buscarGraduado();
    }

    onMount(async () => {
        let cuerpo = new FormData();
        cuerpo.append("accion", "consulta");
        cuerpo.append("token", $usucon.token);
        const json = await apiRol.procesar(cuerpo);

        if (json.error) {
            hayError.error = true;
            hayError.mensaje = json.mensaje;
            if (json.resesion) {
                usucon.resesion(json.mensaje);
            }
        } else {
            roles = [...json.datos];
            usucon.retoken(json.token);
        }
    });

    async function buscarGraduado() {
        let cuerpo = new FormData();
        cuerpo.append("graduadoId", graduadoId);
        cuerpo.append("token", $usucon.token);
        cuerpo.append("origen", origen);
        const json = await api.procesar(cuerpo);

        if (json.error) {
            hayError.error = true;
            hayError.mensaje = json.mensaje;
            if (json.resesion) {
                usucon.resesion(json.mensaje);
            }
        } else {
            gg = json.datos;
            usucon.retoken(json.token);
        }
    }

    async function grabar() {
        displayModalProcesando = "block";
        displayModal = "block";
        let cuerpo = new FormData();
        cuerpo.append("accion", "grabar");
        cuerpo.append("clave_ucc", gg.clave_ucc);
        cuerpo.append("token", $usucon.token);

        for (const element of campos) {
            if (gg[element] !== "") {
                cuerpo.append(element, gg[element]);
            }
        }

        const json = await api.procesar(cuerpo);

        if (json.error) {
            hayError.error = true;
            hayError.mensaje = json.mensaje;
            if (json.resesion) {
                usucon.resesion(json.mensaje);
            }
        } else {
            //console.log("grabo:", json.token);
            //usucon.retoken(json.token);
            //volver();

            displayModalMensaje = json.mensaje;
            displayModalProcesando = "none";
            displayModalRespuesta = "block";
        }
    }

    function pais_elegido(event) {
        //console.log("pais elegido:", event.detail);
        gg.pais = event.detail.nombre;
        gg.cod_pais = event.detail.iso;
        paises_display = "none";
    }

    function volver() {
        dispatch("volver");
    }
</script>

{#if gg}
    <div class="w3-bar w3-black">
        <button
            class="w3-bar-item w3-button"
            on:click={() => (ficha = "usuario")}>Usuario</button
        >
        <button class="w3-bar-item w3-button" on:click={() => (ficha = "datos")}
            >Datos</button
        >
        <button
            class="w3-bar-item w3-button"
            on:click={() => (ficha = "laborales")}>Laborales</button
        >
        <button
            class="w3-bar-item w3-button"
            on:click={() => (ficha = "carreras")}>Carreras</button
        >
        <button class="w3-bar-item w3-button w3-right" on:click={volver}
            >Salir</button
        >
        <button class="w3-bar-item w3-button w3-right" on:click={grabar}
            >Grabar</button
        >
    </div>

    {#if ficha == "usuario"}
        <div class="w3-container">
            <div class="w3-section w3-small">
                <label for="clave_ucc">Clave UCC:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round"
                    style="width:100px; background-color:paleGreen; color:gray"
                    name="clave_ucc"
                    readonly
                    bind:value={gg.clave_ucc}
                />
            </div>

            <div class="w3-section w3-small">
                <label for="apellido">Apellido:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round"
                    name="apellido"
                    readonly
                    style="background-color:paleGreen; color:gray"
                    bind:value={gg.apellido}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="nombre">Nombre:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round"
                    name="nombre"
                    readonly
                    style="background-color:paleGreen; color:gray"
                    bind:value={gg.nombre}
                />
            </div>
        </div>
        <div class="w3-row-padding">
            <div class="w3-third w3-section w3-small">
                <label for="email">eMail:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="eMail"
                    bind:value={gg.email}
                />
            </div>
            <div class="w3-third w3-section w3-small">
                <label for="email">eMail alternativo:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="eMail"
                    maxlength="60"
                    bind:value={gg.emailalt}
                />
            </div>
            <div class="w3-third w3-section w3-small">
                <label for="email">eMail laboral:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="eMail"
                    maxlength="60"
                    bind:value={gg.emaillab}
                />
            </div>
        </div>
        <div class="w3-container">
            <div class="w3-section w3-small">
                <label for="dni">DNI:</label>
                <input
                    readonly
                    type="text"
                    class="w3-input w3-border w3-round"
                    style="background-color:paleGreen; color:gray"
                    name="dni"
                    bind:value={gg.dni}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="fechaNacimiento">Fecha de nacimiento:</label>
                <input
                    readonly
                    type="date"
                    class="w3-input w3-border w3-round"
                    style="background-color:paleGreen; color:gray"
                    name="fechaNacimiento"
                    bind:value={gg.fechaNacimiento}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="sexo">Sexo:</label>
                <select
                    disabled
                    name="sexo"
                    bind:value={gg.sexo}
                    class="w3-select w3-border w3-round"
                    style="width:150px; background-color:paleGreen; color:gray"
                >
                    {#each sexos as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>

            <!--             <div class="w3-half w3-small">
                <label for="rol">Rol:</label>
                {#if roles.length > 0}
                    <select
                        name="rol"
                        bind:value={gg.role_id}
                        class="w3-select w3-border w3-round w3-light-grey"
                        style="width:200px"
                    >
                        {#each roles as rol}
                            <option value={rol.id}>
                                {rol.title}
                            </option>
                        {/each}
                    </select>
                {/if}
            </div> -->
        </div>
    {/if}

    {#if ficha == "datos"}
        <div class="w3-container">
            <div class="w3-section w3-small">
                <label for="domicilio">Domicilio:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="domicilio"
                    bind:value={gg.domicilio}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="localiad">Localidad:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="localidad"
                    bind:value={gg.localidad}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="provincia">Provincia:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="provincia"
                    bind:value={gg.provincia}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="pais">País:</label>
                <!-- <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="pais"
                    bind:value={gg.pais}
                /> -->
                <input
                    type="button"
                    style="text-align: left;"
                    on:click={() => (paises_display = "block")}
                    class="w3-input w3-border w3-round w3-light-grey"
                    bind:value={gg.pais}
                />
            </div>

            <div class="w3-section w3-small">
                <label for="hijos">Hijos:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="hijos"
                    bind:value={gg.hijos}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="familiaEnLaUcc">Familiares en la UCC:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="familiaEnLaUcc"
                    bind:value={gg.familiaEnLaUcc}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="telefonoFijo">Teléfono fijo:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="telefonoFijo"
                    bind:value={gg.telefonoFijo}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="telefonoMovil">Teléfono móvil:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="telefonoMovil"
                    bind:value={gg.telefonoMovil}
                />
            </div>
        </div>
    {/if}

    {#if ficha == "laborales"}
        <div class="w3-container">
            <div class="w3-section w3-small">
                <label for="linkedin">LinkedIn:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="linkedin"
                    bind:value={gg.linkedin}
                />
            </div>

            <div class="w3-section w3-small">
                <label for="activoLaboral">Trabaja actualmente:</label>
                <select
                    name="activoLaboral"
                    bind:value={gg.activoLaboral}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each trabaja as t}
                        <option value={t.id}>
                            {t.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="profIndependiente">Profesional independiente:</label
                >
                <select
                    name="profIndependiente"
                    bind:value={gg.profIndependiente}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each independiente as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="fundador">Empresa propia/fundador:</label>
                <select
                    name="fundador"
                    bind:value={gg.fundador}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each fundador as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="emprendedor">Emprenderor:</label>
                <select
                    name="emprendedor"
                    bind:value={gg.emprendedor}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each emprendedor as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="trabajaUcc">Trabaja en la UCC:</label>
                <select
                    name="trabajaUcc"
                    bind:value={gg.trabajaUcc}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each ucc as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="trabajaUccFaviola"
                    >Trabaja en la Clínica Reina Fabiola:</label
                >
                <select
                    name="trabajaUccFabiola"
                    bind:value={gg.trabajaUccFabiola}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each fabiola as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>
            <div class="w3-section w3-small">
                <label for="proveedorUcc">Es proveedor de la UCC:</label>
                <select
                    name="proveedorUcc"
                    bind:value={gg.proveedorUcc}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="width:250px"
                >
                    {#each proveedor as s}
                        <option value={s.id}>
                            {s.desc}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="w3-section w3-small">
                <label for="organizacion">Organización en la que trabaja:</label
                >
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="organizacion"
                    bind:value={gg.organizacion}
                />
            </div>
            <div class="w3-section w3-small">
                <label for="webOrganizacion">Web de la Organizacion:</label>
                <input
                    type="text"
                    class="w3-input w3-border w3-round w3-light-grey"
                    name="webOrganizacion"
                    bind:value={gg.webOrganizacion}
                />
            </div>

            <div class="w3-section w3-small">
                <label for="fallecido">Asistió a un evento UCC:</label>

                <select
                    name="uccEventoAsistio"
                    bind:value={gg.uccEventoAsistio}
                    class="w3-select w3-border w3-round w3-light-grey"
                    style="max-width:150px"
                    on:blur={() => {
                        if (parseInt(gg.uccEventoAsistio) == 0)
                            gg.uccEvento = "  ";
                    }}
                >
                    {#each uccEventoAsistio as f}
                        <option value={f.id}>
                            {f.desc}
                        </option>
                    {/each}
                </select>

                <textarea
                    disabled={gg.uccEventoAsistio == "0"}
                    class="w3-input w3-border w3-round w3-light-grey"
                    bind:value={gg.uccEvento}
                />
            </div>
        </div>
    {/if}

    {#if ficha == "carreras"}
        <Carreras {graduadoId} />
    {/if}
{:else}
    <h3>Procesando...</h3>
{/if}

<div class="w3-modal" style="display:{displayModal}">
    <div class="w3-modal-content w3-card-4" style="margin-top:30px">
        <header class="w3-container w3-blue">
            <h3>Actualización de Datos</h3>
        </header>
        <div class="w3-container" style="display:{displayModalRespuesta}">
            <div class="w3-section">
                <p class="w3-medium">{displayModalMensaje}</p>
            </div>
            <div class="w3-section">
                <button
                    class="w3-btn w3-medium w3-blue w3-round"
                    on:click={() => {
                        displayModalRespuesta = "none";
                        displayModalProcesando = "none";
                        displayModal = "none";
                        displayModalMensaje = "";
                    }}>Continuar</button
                >
            </div>
        </div>
        <div class="w3-container" style="display:{displayModalProcesando}">
            <div class="w3-section">
                <p class="w3-medium">Procesando...</p>
            </div>
        </div>
    </div>
</div>

<Paises
    display={paises_display}
    on:elegido={pais_elegido}
    on:cerrar={() => (paises_display = "none")}
/>
